import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { EButton, EFormSection, EPageTitle, ESelect } from 'libs/ui';

import PageLayout from 'PageLayout';

import useMaster from 'hook/useMaster';

import HotelCommission from './FormSections/HotelCommission';
import FlightCommission from './FormSections/FlightCommission';

export default function CreateCommissionB2C() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const service = searchParams.get("service");
    const commissionId = searchParams.get("id");

    const {
        serviceTypes,
        getServiceTypes
    } = useMaster();


    const flightCommissionFormRef = useRef<any>(null);

    const [selectedService, setSelectedService] = useState<string | null>();
    const [isSaving, setIsSaving] = useState(false);


    useEffect(() => {
        getServiceTypes();
    }, []);

    useEffect(() => {
        if (service && commissionId) {
            setSelectedService(service);
        };
    }, [service, commissionId]);


    // HANDLER FUNCTIONS
    const handleSubmit = () => {
        switch (selectedService) {
            case "FLIGHT":
                flightCommissionFormRef.current?.save();
                break;
            case "HOTEL":
                break;
            default:
                break;
        };
    };


    return (
        <PageLayout>
            <EPageTitle
                title="Create New Commission - B2B"
                end={
                    <div className="flex gap-2">
                        <EButton
                            variant="outline"
                            onClick={() => navigate(-1)}
                        >Cancel</EButton>
                        <EButton
                            disabled={!selectedService}
                            loading={isSaving}
                            onClick={handleSubmit}
                        >Save</EButton>
                    </div>
                }
            />
            <div>
                <EFormSection
                    title="Service"
                    subtitle="Please select service"
                >
                    <ESelect
                        // label="Service"
                        placeholder="Select"
                        data={serviceTypes}
                        value={selectedService}
                        onChange={(value) => setSelectedService(value)}
                    />
                </EFormSection>

                {
                    selectedService === "FLIGHT"
                        ?
                        <FlightCommission
                            // isSaving={isSaving}
                            setIsSaving={setIsSaving}
                            selectedService={selectedService}
                            ref={flightCommissionFormRef}
                        />
                        :
                        selectedService === "HOTEL"
                            ?
                            <HotelCommission />
                            :
                            <></>
                }
            </div>
        </PageLayout>
    )
}